"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.sourceType.group': 'Grupo',
    'whatsapp.sourceType.dm': 'MD',
    'whatsapp.sourceType.email': 'Correo',
};
